import axios from 'axios';

export const testimonialsService = {
  async getAll() {
    const res = await axios.get('/testimonials');
    return res.data.data || [];
  },

  async getMine() {
    const res = await axios.get('/my-testimonial');
    return res.data.data || null;
  },

  async save(note, numberOfStars) {
    const res = await axios.post('/testimonials', {
      note,
      number_of_stars: numberOfStars,
    });
    return res.data;
  },
};
